<script setup lang="ts">
// Vue & Plugins
import { ref } from 'vue'

// Components
import Menu from 'primevue/menu'

// Models
import { User } from '../../users/models/user'
import { useRouter } from 'vue-router'
import EmployeeAvatar from '../../employees/components/misc/EmployeeAvatar.vue'

// Data
defineProps<{
  user: User,
}>()

const emit = defineEmits<{
  logOut: [],
}>()

const router = useRouter()
const menu = ref<InstanceType<typeof Menu>>()
const items = ref([
  {
    label: 'Profile',
    icon: 'pi pi-user',
    command: () => router.push({ name: '/(app)/user/settings' }),
  },
  {
    separator: true,
  },
  {
    label: 'Log Out',
    icon: 'pi pi-sign-out',
    command: () => emit('logOut'),
  },
])

const toggle = (event: Event) => {
  menu.value?.toggle(event)
}
</script>

<template>
  <Button
    v-bind="$attrs"
    severity="secondary"
    rounded
    aria-haspopup="true"
    aria-controls="overlay_menu"
    @click="toggle"
  >
    <template #icon>
      <EmployeeAvatar
        :avatar="user.avatarUrl"
        :name="user.displayName"
        size="large"
      />
    </template>
  </Button>
  <SimpleMenu
    id="overlay_menu"
    ref="menu"
    :model="items"
    :popup="true"
  />
</template>